import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@mui/material/CardActions';
import CardActionArea from '@mui/material/CardActionArea';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import WebAssetIcon from '@mui/icons-material/WebAsset';
import WebIcon from '@mui/icons-material/Web';
import { makeStyles } from '@mui/styles';
import { darkTheme } from '../Layout/Theme';

const useStyles = makeStyles({
  root: {
    maxWidth: 800,
  },
  header: {
    textAlign: 'center',
  },
  media: {
    height: 320,
    width: 200,
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  actions: {
    padding: 0,
    flexWrap: 'wrap',
    '& a': {
      marginTop: '1em',
      marginLeft: '0!important',
      marginRight: '1em',
    },
  },
});

const Dashboard = () => {
  const classes = useStyles();
  return (
    <ThemeProvider theme={darkTheme}>
      <Card className={classes.root}>
        <CardHeader
          className={classes.header}
          title="Welcome to the PARS Administration Panel"
        />
        <CardActionArea>
          <CardMedia
            className={classes.media}
            image="https://pars-ui.pages.dev/static/falcibaci-365a343e9e06600e3b2f77deaf447b4e.png"
            title="Falci Baci"
          />
        </CardActionArea>
        <CardContent>
          <Typography variant="body2" color="textSecondary" component="p">
            This panel aims to manage promo access and reporting services.
            You can access the channels, partners, campaigns, bundles, and codes easily
          </Typography>
          <CardActions className={classes.actions}>
            <Button
              variant="contained"
              href="https://pars-ui.pages.dev"
              startIcon={<WebAssetIcon />}>
              Pars UI Development Website
            </Button>
            <Button
              variant="contained"
              href="https://kod.kaavefali.com"
              startIcon={<WebIcon />}>
              Pars UI Production Website
            </Button>
          </CardActions>
        </CardContent>
      </Card>
    </ThemeProvider>
  );
};
export default Dashboard;